import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

function TimePicker(props) {
  const {
    value,
    helperText,
    label,
    error,
    fullWidth,
    inputId,
    name,
    disabled,
    onChange,
  } = props;

  const [stateValue, setStateValue] = useState(value || '');

  useEffect(() => {
    setStateValue(value || '');
  }, [value]);

  const localOnChange = (event) => {
    setStateValue(event.target.value);
  };

  const handleBlur = (event) => {
    onChange(event, stateValue);
  };

  return (
    <Grid item container>
      <Grid item xs>
        <TextField
          disabled={disabled}
          value={stateValue}
          onBlur={handleBlur}
          onChange={localOnChange}
          fullWidth={fullWidth}
          id={inputId || 'timepicker-simple'}
          label={label || 'Hora'}
          error={error}
          helperText={helperText}
          type="time"
          name={name || 'time-picker-unnamed'}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>
  );
}

export default TimePicker;
